import React from 'react'
import { FormattedMessage } from 'react-intl'

const Results: React.FC = () => {
  return (
    <div>
      <h1 className="text-text-heading text-2xl font-semibold">
        <FormattedMessage id="results.heading" defaultMessage="Results" />
      </h1>
      <p className="text-text-body mt-2 text-sm">
        <FormattedMessage id="results.body" defaultMessage="Placeholder page for test results and reports." />
      </p>
    </div>
  )
}

export default Results
